import VisualizarCompraServico from './VisualizarCompraServico';

export default VisualizarCompraServico;
